import { useReducedMotion as useMantineReducedMotion } from '@mantine/hooks';

/**
 * Hook to detect if user prefers reduced motion
 * Uses system preference and can be overridden
 * All animations should respect this for accessibility
 */
export function useReducedMotion(): boolean {
  return useMantineReducedMotion() ?? false;
}

export default useReducedMotion;
